import { connect } from 'react-redux';

import { GET_PLACE_DETAIL, RESET_PLACE_DETAILS } from 'store/place/actionTypes';

import NearLocation from './NearLocation';

const mapStateToProps = (state) => ({
  isLoadingGetSetting: state.Setting.isLoadingGetSetting,
  isLoadingGetPlaceDetail: state.Place.isLoadingGetPlaceDetail,

  setting: state.Setting.setting,
  placeDetail: state.Place.placeDetail,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetPlaceDetail: (payload) => dispatch({
    type: GET_PLACE_DETAIL,
    payload,
  }),

  actionResetPlaceDetail: () => dispatch({
    type: RESET_PLACE_DETAILS,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(NearLocation);
